import { useState, useRef, useEffect } from 'react';

// Self-contained settings button + popup panel.
// Opens on click; closes when clicking outside (via mousedown listener on document).
// Children are rendered as the popup body (use <SettingsRow> for each row).
export function SettingsPopup({ children }) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handler = e => {
            if (anchorRef.current && !anchorRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open]);

    return (
        <div className="settings-anchor" ref={anchorRef}>
            <button
                className="settings-btn"
                onClick={() => setOpen(o => !o)}
                title="Settings"
            >⚙</button>
            {open && (
                <div className="settings-popup">
                    <div className="settings-popup-title">Settings</div>
                    {children}
                </div>
            )}
        </div>
    );
}

// A single label + control row inside a SettingsPopup.
export function SettingsRow({ label, children }) {
    return (
        <div className="settings-row">
            <span className="settings-row-label">{label}</span>
            {children}
        </div>
    );
}

// A styled toggle switch that fits the dark colour scheme.
// ON  → blue track (#0e639c) + light thumb
// OFF → dark track (#3c3c3c) + dim thumb
export function Toggle({ value, onChange }) {
    return (
        <button
            role="switch"
            aria-checked={value}
            className={`settings-toggle${value ? ' settings-toggle-on' : ''}`}
            onClick={() => onChange(!value)}
        >
            <span className="settings-toggle-thumb" />
        </button>
    );
}
